var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34172 2.34167C1.15839 3.51667 1.15839 7.34167 2.34172 8.49167C3.22998 9.14057 4.31951 9.45355 5.41672 9.37501C6.51394 9.45355 7.60347 9.14057 8.49172 8.49167C9.67506 7.31667 9.67506 3.49167 8.49172 2.34167C7.30839 1.19167 3.51672 1.15834 2.34172 2.34167Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34172 11.5083C1.15839 12.6833 1.15839 16.5083 2.34172 17.6583C3.22998 18.3072 4.31951 18.6202 5.41672 18.5417C6.51394 18.6202 7.60347 18.3072 8.49172 17.6583C9.67506 16.4833 9.67506 12.6583 8.49172 11.5083C7.30839 10.3583 3.51672 10.325 2.34172 11.5083Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 9.37501C15.6806 9.45355 16.7701 9.14057 17.6583 8.49167C18.8417 7.31667 18.8417 3.49167 17.6583 2.34167C16.475 1.19167 12.6583 1.15834 11.5083 2.34167C10.3583 3.52501 10.325 7.34167 11.5083 8.49167C12.3966 9.14057 13.4861 9.45355 14.5833 9.37501Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5083 11.5083C10.325 12.6833 10.325 16.5083 11.5083 17.6583C12.3966 18.3072 13.4861 18.6202 14.5833 18.5417C15.6806 18.6202 16.7701 18.3072 17.6583 17.6583C18.8417 16.4833 18.8417 12.6583 17.6583 11.5083C16.475 10.3583 12.6833 10.325 11.5083 11.5083Z",
    fill: "#8F8C9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.b661fd6be4db3163247e998c403c1c19.svg";
export { ForwardRef as ReactComponent };